module.exports = __webpack_public_path__ + "img/us.1137e6ca.svg";